import type { Action, Dispatch, ReducersMapObject, Store } from "redux";
import type { TypedUseSelectorHook } from "react-redux";
import { useSelector, useDispatch } from "react-redux";
import type { ModelActionsType } from "./actions/ModelActions";
import { getInitStoreByReducers } from "../../../../common-deprecated/redux/storeHelpers";
import carReducer from "./reducers/CarReducer";
import carItemReducer from "./reducers/CarItemReducer";
// @ts-ignore
import basketReducer from "./reducers/BasketReducer";
import utilReducer from "../../../../common-deprecated/redux/reducers/UtilReducer";
import modalReducer from "../../../../common-deprecated/redux/reducers/ModalReducer";
import notificationReducer from "../../../../common-deprecated/redux/reducers/NotificationReducer";
import etaReducer from "./reducers/EtaReducer";
import modelReducer from "./reducers/ModelReducer";
import gradeReducer from "./reducers/GradeReducer";
import type { SubModelReducerType } from "./reducers/SubmodelReducer";
import submodelReducer from "./reducers/SubmodelReducer";
import type { SaveStateType } from "./reducers/SaveReducer";
import saveReducer from "./reducers/SaveReducer";
import type { NavigationStateType } from "./reducers/NavigationReducer";
import navigationReducer from "./reducers/NavigationReducer";
import type { ModelFilterStateType } from "./reducers/ModelFilterReducer";
import modelFilterReducer from "./reducers/ModelFilterReducer";
import type { FinanceRateStateType } from "./reducers/FinanceRateReducer";
import financeReducer from "./reducers/FinanceRateReducer";
import type { BuildInsuranceRateStateType } from "./reducers/InsuranceRateReducer";
import insuranceRateReducer from "./reducers/InsuranceRateReducer";
import externalPriceReducer from "./reducers/ExternalPriceReducer";
import type { MassManagementStateType } from "./reducers/MassManagementReducer";
import massManagementReducer from "./reducers/MassManagementReducer";
import type { PSLSStateType } from "./reducers/PSLSReducer";
import pslsReducer from "./reducers/PSLSReducer";
import type { TransactionLogicStateType } from "../../../../common-deprecated/redux/reducers/TransactionReducer";
import transactionReducer from "../../../../common-deprecated/redux/reducers/TransactionReducer";
import type { SpecStateType } from "./reducers/SpecReducer";
import specReducer from "./reducers/SpecReducer";
import type { ExtrasFilterStateType } from "./reducers/ExtrasFilterReducer";
import extrasFilterReducer from "./reducers/ExtrasFilterReducer";
import type { GradeType } from "../../../../common-deprecated/types/GradeType";
import type { EtaStateType, ModelType } from "../../../../common-deprecated/types/CommonTypes";
import type { BasketType } from "../../../shared-logic/types/BasketType";
import type { CreateLogicType, ItemsType } from "../../../../common-deprecated/redux/typeHelpers";
// @ts-ignore
import transactionLogic from "./logic/TransactionLogic";
import navigationLogic from "./logic/NavigationLogic";
import utilLogic from "./logic/UtilLogic";
import commonUtilLogic from "../../../../common-deprecated/redux/logic/CommonUtilLogic";
// @ts-ignore
import basketLogic, { basketServerLogic } from "./logic/BasketLogic";
import saveLogic, { serverLogic as saveServerLogic } from "./logic/SaveLogic";
// @ts-ignore
import etaLogic from "./logic/EtaLogic";
import modelFilterLogic from "./logic/ModelFilterLogic";
import financeInsuranceLogic, { financeInsuranceServerLogic } from "./logic/FinanceInsuranceLogic";
import buyReserveLogic, { serverLogic as buyReserveServerLogic } from "./logic/BuyReserveLogic";
import historyLogic from "./logic/HistoryLogic";
import massManagementLogic from "./logic/MassManagementLogic";
import specLogic from "./logic/specLogic";
import CommonSettingsReducer from "../../../../common-deprecated/redux/reducers/CommonSettingsReducer";
import type { GradesReducerType } from "./reducers/GradesReducer";
import gradesReducer from "./reducers/GradesReducer";
import type { BnbSettingsType } from "./reducers/BnbSettingsReducer";
import BnbSettingsReducer from "./reducers/BnbSettingsReducer";
import type { SaveActionsType } from "./actions/SaveActions";
import type { FinanceInsuranceActionsType } from "./actions/FinanceInsuranceActions";
import type { NavigationActionsType } from "./actions/NavigationActions";
import type { SpecActionsType } from "./actions/SpecActions";
import type { EtaActionsType } from "./actions/EtaActions";
import type { ExternalPriceActionsType } from "./actions/ExternalPriceActions";
import type { MassManagementActionType } from "./actions/MassManagementActions";
import type { ExtrasFilterActionsType } from "./actions/ExtrasFilterActions";
import type { ModelFilterActionsType } from "./actions/ModelFilterActions";
import type { CarItemsActionsType } from "./actions/CarItemActions";
import type { GradeActionsType } from "./actions/GradeActions";
import type { CarActionsType } from "./actions/CarActions";
import type { BasketActionsType } from "./actions/BasketActions";
import type { TransactionActionType } from "../../../../common-deprecated/redux/actions/TransactionActions";
import type { SubmodelActionsType } from "./actions/SubmodelActions";
import type { GradesActionType } from "./actions/GradesActions";
import type { BnbSettingsActionsType } from "./actions/BnbSettingsActions";
import type { RetailerSettingsActionsType } from "../../../../shared-logic/features/retailer/redux/actions/RetailerSettingsActions";
import type { RetailerSettingsType } from "../../../../shared-logic/features/retailer/redux/reducers/RetailerSettingsReducer";
import RetailerSettingsReducer from "../../../../shared-logic/features/retailer/redux/reducers/RetailerSettingsReducer";
import type { TradeInAemExternalDataReducerType } from "../../../../common-deprecated/features/tradein/redux/reducers/TradeInAemExternalDataReducer";
import TradeInAemExternalDataReducer from "../../../../common-deprecated/features/tradein/redux/reducers/TradeInAemExternalDataReducer";
import type { TradeInAemExternalDataActions } from "../../../../common-deprecated/features/tradein/redux/actions/TradeInAemExternalDataActions";
import tradeInAemExternalDataLogic from "./logic/TradeInAemExternalDataLogic";
import type { CommonActionsType, CommonReducerType } from "../../../../common-deprecated/redux/commonStore";
import type { CarType } from "../../../shared-logic/types/CarType";
import type { NotificationActionsType } from "../../../../common-deprecated/redux/actions/NotificationActions";
import type { ExternalPriceStateType } from "../../../shared-logic/types/externalPriceTypes";
import type { NewCarCompareExternalDataActionsType } from "../../../../common-deprecated/features/compare/redux/actions/NewCarCompareExternalDataActions";
import type {
    EcoConsumptionActionsType,
    EcoConsumptionStateType,
} from "../../../shared-modules/eco-consumption-section/redux/reducers/EcoConsumptionReducer";
import EcoConsumptionReducer from "../../../shared-modules/eco-consumption-section/redux/reducers/EcoConsumptionReducer";
import ecoConsumptionLogic from "../../../shared-modules/eco-consumption-section/redux/logic/EcoConsumptionLogic";

export type BuildAndBuyStateType = CommonReducerType & {
    car: CarType;
    items: ItemsType;
    grade: GradeType;
    submodels: SubModelReducerType;
    grades: GradesReducerType;
    model: ModelType;
    basket: BasketType;
    modelFilter: ModelFilterStateType;
    eta: EtaStateType;
    bnbSettings: BnbSettingsType; // Use this instead!
    retailerSettings: RetailerSettingsType;
    save: SaveStateType;
    finance: FinanceRateStateType;
    psls: PSLSStateType;
    transaction: TransactionLogicStateType;
    externalPrice: ExternalPriceStateType;
    massManagement: MassManagementStateType;
    specs: SpecStateType;
    navigation: NavigationStateType;
    insuranceRate: BuildInsuranceRateStateType;
    extrasFilter: ExtrasFilterStateType;
    tradeInAemExternalData: TradeInAemExternalDataReducerType;
    ecoConsumption: EcoConsumptionStateType;
};

export type BuildAndBuyActionsType =
    | CommonActionsType
    | SaveActionsType
    | FinanceInsuranceActionsType
    | NavigationActionsType
    | SpecActionsType
    | EtaActionsType
    | ExternalPriceActionsType
    | MassManagementActionType
    | ExtrasFilterActionsType
    | ModelFilterActionsType
    | CarItemsActionsType
    | ModelActionsType
    | NotificationActionsType
    | GradeActionsType
    | CarActionsType
    | BasketActionsType
    | TransactionActionType
    | SubmodelActionsType
    | GradesActionType
    | BnbSettingsActionsType
    | RetailerSettingsActionsType
    | TradeInAemExternalDataActions
    | NewCarCompareExternalDataActionsType
    | EcoConsumptionActionsType;

export type BuildAndBuyDispatchType = Dispatch<BuildAndBuyActionsType>;
export type BuildAndBuyLogicType<ActionType extends Action> = CreateLogicType<
    ActionType,
    BuildAndBuyStateType,
    BuildAndBuyDispatchType
>;

export type BuildAndBuyStoreType = Store<BuildAndBuyStateType, BuildAndBuyActionsType>;

export const useBnbDispatch = useDispatch<BuildAndBuyDispatchType>;

export const useBnbSelector: TypedUseSelectorHook<BuildAndBuyStateType> = useSelector;

export const buildAndBuyClientLogic = [
    ...transactionLogic,
    // Keep navigationlogic up high, it can prevent some navigation from happening resulting in logic not needing to be triggered.
    ...navigationLogic,
    ...utilLogic,
    ...commonUtilLogic,
    ...basketLogic,
    ...saveLogic,
    ...etaLogic,
    ...massManagementLogic,
    ...modelFilterLogic,
    ...financeInsuranceLogic,
    ...buyReserveLogic,
    ...historyLogic,
    ...tradeInAemExternalDataLogic,
    ...specLogic,
    ...ecoConsumptionLogic,
];
export const buildAndBuyServerLogic = [
    ...saveServerLogic,
    ...buyReserveServerLogic,
    ...basketServerLogic,
    ...financeInsuranceServerLogic,
    ...modelFilterLogic,
    ...ecoConsumptionLogic,
];

export const buildAndBuyReducers: ReducersMapObject<BuildAndBuyStateType, any> = {
    car: carReducer,
    items: carItemReducer,
    basket: basketReducer,
    utils: utilReducer,
    modal: modalReducer,
    notification: notificationReducer,
    eta: etaReducer,
    model: modelReducer,
    submodels: submodelReducer,
    grades: gradesReducer,
    grade: gradeReducer,
    save: saveReducer,
    navigation: navigationReducer,
    modelFilter: modelFilterReducer,
    finance: financeReducer,
    insuranceRate: insuranceRateReducer,
    externalPrice: externalPriceReducer,
    massManagement: massManagementReducer,
    psls: pslsReducer,
    transaction: transactionReducer,
    specs: specReducer,
    extrasFilter: extrasFilterReducer,
    bnbSettings: BnbSettingsReducer,
    commonSettings: CommonSettingsReducer,
    retailerSettings: RetailerSettingsReducer,
    tradeInAemExternalData: TradeInAemExternalDataReducer,
    ecoConsumption: EcoConsumptionReducer,
};

export const buildAndBuyClientStore = getInitStoreByReducers(buildAndBuyReducers, buildAndBuyClientLogic);
export const buildAndBuyServerStore = getInitStoreByReducers(buildAndBuyReducers, buildAndBuyServerLogic);
